import React from 'react'
import './goods-item.less'

class GoodsItem extends React.Component<any> {
  render() {
    const goods = Object.assign({}, this.props.goods)

    return (
      <div className="goods-item">
        <img src={goods.cover} alt="anxin.png" />
        <div className="text ">
          <div className="text-ell font-7">{goods.title}</div>
          <div className="text-ell retail font-8">
            零售价： {goods.original_price}
          </div>
          <div className="add-delete font-8">
            <div className="text-ell member-price font-8 font_yellow">
              会员价：{goods.current_price}
            </div>
            <span className="font-8">x{goods.num}</span>
          </div>
        </div>
      </div>
    )
  }
}
export default GoodsItem
